/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

export interface SystemOptions extends Record<string, any> {
    platformUrl: string;
    sentryUrl: string | null;
    appBaseUrl: string;
    gaID: string | null;
    mode: 'prod' | 'test' | 'dev';
    staticURL: string;
    URL: string;
    tinyAPIKey: string;
}

interface Settings extends Record<string, SystemOptions> {
    prod: SystemOptions;
    dev: SystemOptions;
    accept: SystemOptions;
}

const defaultSettings: SystemOptions = {
    mode: 'prod',
    platformUrl: '',
    sentryUrl: null,
    appBaseUrl: '',
    gaID: null,
    staticURL: '',
    URL: '',
    tinyAPIKey: '0pdhayykjtfwu6s03da4co7s0o4jxohguk6wq2cxgs6k6mh6',
};

const appSettings: Settings = {
    prod: {
        ...defaultSettings,
        platformUrl: 'https://devuurvogel-uithoorn.nl/vuurvogel-core/v1',
        staticURL: 'https://devuurvogel-uithoorn.nl/static',
        URL: 'https://devuurvogel-uithoorn.nl',
    },
    accept: {
        ...defaultSettings,
        mode: 'test',
        platformUrl: 'https://vuurvogel.davevanrijn.nl/vuurvogel-core/v1',
        staticURL: 'https://vuurvogel.davevanrijn.nl/static',
        URL: 'https://vuurvogel.davevanrijn.nl',
    },
    dev: {
        ...defaultSettings,
        mode: 'dev',
        platformUrl: 'http://127.0.0.1:30377/v1',
        staticURL: 'https://devuurvogel-uithoorn.nl/static',
        URL: 'http://127.0.0.1:1337'
    }
};

const mode = window.mode || 'prod';
window.settings = appSettings[mode];
